export const unauthorized = async (error, history) => {
  if (!error || error.status !== 401) return;

  localStorage.removeItem('token');
  return await history.replace({
    pathname: '/connexion',
    state: error.message,
  });
};
